export interface SetPasswordRequest {
  email: string
  password: string
  token: string
}

export interface SetPasswordResponse {
  message: string
  data: Data
}

interface Data {
  email: string
  role: string
  hasFullAccess: string
}
